module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray-e82b13f2bbdd7e4c386e38e7f57b3d4f.png";